import { ContactType } from '@api/generated/graphql';
import {
  ActionMenu,
  BodyText,
  Button,
  Icon,
} from '@servicetitan/design-system';
import { phoneContactMethodOptionsArray } from '../../ContactMethodDefinitions';
import strings from '../../strings';
import { getTestIdProps } from '@lib/testUtils';
import { inboxLocators } from '@locators/inbox';

type ContactMethodIconMenuProps = {
  isPhoneOrMobile: boolean;
  iconType: 'phone' | 'email' | 'phone_iphone' | 'print' | 'help';
  onChangeType: (type: ContactType, index: number) => void;
  index: number;
  isContactTypeMenuOpen: boolean;
  onContactTypeMenuOpenChange: (open: boolean) => void;
};

const ContactMethodIconMenu = ({
  isPhoneOrMobile,
  iconType,
  onChangeType,
  index,
  isContactTypeMenuOpen,
  onContactTypeMenuOpenChange,
}: ContactMethodIconMenuProps) => {
  const handleItemClick = (type: ContactType) => {
    onChangeType(type, index);
    onContactTypeMenuOpenChange(false);
  };

  const onClickOutside = () => {
    onContactTypeMenuOpenChange(false);
  };

  const onClickMenu = () => {
    onContactTypeMenuOpenChange(!isContactTypeMenuOpen);
  };

  if (isPhoneOrMobile) {
    return (
      <ActionMenu
        width='s'
        direction='br'
        open={isContactTypeMenuOpen}
        onClickOutside={onClickOutside}
        {...getTestIdProps(
          inboxLocators.customerSearch.contactMethodPhoneTypeMenu,
        )}
        portal
        trigger={
          <Button
            aria-label={strings.labels.phoneToggle}
            fill='subtle'
            primary
            onMouseDown={(e: React.MouseEvent) => {
              e.preventDefault();
              onClickMenu();
            }}
            iconName={iconType}
            size='xsmall'
            {...getTestIdProps(
              inboxLocators.customerSearch.contactMethodPhoneTypeMenuBtn,
            )}
          />
        }
      >
        {phoneContactMethodOptionsArray.map((item) => (
          <ActionMenu.Item
            icon={item.icon}
            key={item.value}
            onClick={() => handleItemClick(item.value)}
            {...getTestIdProps(
              `${inboxLocators.customerSearch.contactMethodPhoneTypeMenu}-${item.value}`,
            )}
          >
            <BodyText>{item.label}</BodyText>
          </ActionMenu.Item>
        ))}
      </ActionMenu>
    );
  } else {
    return <Icon name={iconType} />;
  }
};

export default ContactMethodIconMenu;
